import { Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { FairPaySurveyResponseContext } from "contexts/FairPaySurveyResponse";
import { useContext } from "react";

import LocationAutocomplete from "components/LocationAutocomplete";
import { UserLocation } from "components/LocationAutocomplete/schema";
import {
  FairPayCreatorType,
  FairPayCurrency,
  FairPayEmploymentType,
  FairPayGender,
  FairPayNiche,
} from "features/FairPaySurvey/schemas";
import { makeDeepCopy } from "utils/updateLocalState";

import FairPaySelect from "../components/FairPaySelect";

const styles = {
  locationAutocomplete: {
    borderRadius: 4,
    border: "1px solid black",
    width: "100%",
    height: 55,
    py: 2,
    px: 2,
    fontFamily: "'Inter', sans-serif",
    "&:hover, &:focus": {
      outline: "none",
    },
    fontSize: 14,
    "::placeholder": {
      color: grey[500],
    },
    mb: 2,
  },
};

const FairPayAboutYou = () => {
  const { fairPaySurveyResponse, setFairPaySurveyResponse } = useContext(
    FairPaySurveyResponseContext,
  );

  const handleLocationChange = (userLocation: UserLocation) => {
    if (!fairPaySurveyResponse) return;
    setFairPaySurveyResponse((prev) => {
      const copy = makeDeepCopy(prev) || {};
      copy.addressComponents = userLocation?.address_components;
      return copy;
    });
  };

  return (
    <>
      <Typography variant="h4" textAlign={"center"} sx={{ mb: 2 }}>
        About You
      </Typography>
      <FairPaySelect
        label={"Your Niche / Category"}
        options={Object.values(FairPayNiche)}
        selectedOption={fairPaySurveyResponse?.niche}
        name="niche"
        required={true}
      />
      <LocationAutocomplete
        handleLocationChange={handleLocationChange}
        customStyling={styles.locationAutocomplete}
        placeholderText="Your Location *"
        userLocation={{
          address: fairPaySurveyResponse?.city,
          country_code: fairPaySurveyResponse?.country,
          address_components: fairPaySurveyResponse?.addressComponents,
        }}
      />
      <FairPaySelect
        label={"Gender"}
        options={Object.values(FairPayGender)}
        selectedOption={fairPaySurveyResponse?.gender}
        name="gender"
      />
      <FairPaySelect
        label={"Please select how you identify yourself"}
        options={Object.values(FairPayCreatorType)}
        selectedOption={fairPaySurveyResponse?.creatorType}
        name="creatorType"
      />
      <FairPaySelect
        label={"Are you a full-time or part-time creator?"}
        name="employmentType"
        options={Object.values(FairPayEmploymentType)}
        selectedOption={fairPaySurveyResponse?.employmentType}
        required={true}
      />
      <FairPaySelect
        label={"Currency you get paid in"}
        options={Object.values(FairPayCurrency)}
        selectedOption={fairPaySurveyResponse?.currency}
        name="currency"
      />
    </>
  );
};

export default FairPayAboutYou;
